import React from 'react';
import { Flex } from 'antd-mobile';
import { Button, Icon } from 'react-onsenui';
import { Transition } from 'react-transition-group';
import PropTypes from 'prop-types';

const duration = 300;

const defaultStyle = {
    transition: `opacity ${duration}ms ease-in-out`,
    opacity: 0,
}

const transitionStyles = {
    entering: { opacity: 1 },
    entered:  { opacity: 1 },
    exiting:  { opacity: 0 },
    exited:  { opacity: 0 },
};

class RefreshButton extends React.Component {

    componentDidUpdate(prevProps) {
        if(this.props.inProp !== prevProps.inProp && this.props.inProp === true) {
            try {
                this.props.stopInterval()   
            } catch (error) {
                
            }
        }
    }

    render() {
        return (
            <Transition in={this.props.inProp} timeout={duration}>
                {
                    state => (
                        <Flex justify='center' align='center' alignContent='center' direction='row' style={{
                            ...defaultStyle,
                            ...transitionStyles[state]
                        }}>
                            <Button 
                                style={{borderRadius: '100px', width: '60%', position: 'fixed', zIndex: '111111', top: '50%', backgroundColor: '#004586'}} 
                                modifier='material'
                                onClick={this.props.onClick}
                            >
                                <div>
                                    <Icon style={{float: 'left', marginRight: '5px'}} icon='md-refresh-sync' size={26} />
                                    <div style={{textTransform: 'initial', fontFamily: 'fff-equipe', fontWeight: '700'}}>{this.props.text}</div>
                                </div>
                            </Button>
                        </Flex>
                    )
                }
            </Transition>
        )
    }
}

RefreshButton.propTypes = {
    inProp: PropTypes.bool.isRequired,
    text: PropTypes.string, 
    onClick: PropTypes.func.isRequired,
    stopInterval: PropTypes.func.isRequired
}

export default RefreshButton;